export default {
    TrendoneMegatrend: {
        active: 'The status of the mega-trend is active.<br />It remains active as long as active macro-trends belong to this mega-trend.',
        inactive: 'The status of the mega-trend is inactive.<br />It remains inactive as long as none of the associated macro-trends are activated.'
    },
    TrendoneMacrotrend: {
        active: 'The status of the macro-trend is active',
        inactive: 'The status of the macro-trend is inactive'
    }
}
